export default "__VITE_ASSET__CJ2Pl444__"